import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './PreChat.scss';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import clsx from 'clsx';
import { useDispatch , useSelector } from 'react-redux';
import { signIn, signOut } from "../../redux/actions/preChatActions";
import BeatLoader from "react-spinners/BeatLoader";
import { getUrlParam, createCallUrl, createCallSelectorUrl, decodeEntities, capitalizeWords } from '../../utils/common';
import { useNavigate } from "react-router-dom";
import { setPage } from '../../redux/actions/commonActions';
import useIpAndCountry from '../../hooks/useIpAndCountry';

const PreChat = () => {
    const {user , ui } = useSelector(state=>state);
    const config = ui?.config?.attributes;
    const playerData = ui.player?.data ? ui.player?.data.attributes : null;
    const { ipAddress, countryCode } = useIpAndCountry();
    let lang = "EN";
// console.log(playerData);
    const langMap = {
        "en-IN": "in",
        "kk": "kz",
        "zh-Hans": "cn",
        "ko-KR": "kr",
        "vi": "vn",
        "ne": "np",
        "zh-Hant": "cn",
        "bn-BD": "bd",
        "en-PK": "pk"
        // Add more mappings as needed
    };
    
    lang = config?.locale;
    if (langMap[config?.locale]) {
        lang = langMap[config?.locale];
    }
    lang = lang?.toUpperCase();

    useEffect(() => {
        if (config?.Title) {
            document.title = config.Title;
        }
    }, [config?.Title]);


    const navigate = useNavigate();
    const formikRef = useRef();

    useEffect(() => {
        if (playerData && formikRef.current) {
            const { username, email } = playerData;

            // Dynamically update form values when `playerData` changes
            formikRef.current.setValues({
                firstName: username?.trim() || '',
                lastName: '',
                email: email || '',
                confirmationOrder: '',
                product: '',
                inquiry: '',
                deposit: '',
                engagementParamters: [],
            });
        }
    }, [playerData]);

    let SignupSchema = null;
    let productList = null;
    let inquiryList = null;
    let subinquiryList = null;
    let subinquiryListNew = null;
    const [depositField,setDepositField] = useState(false);
    const [subInquiryField,setSubInquiryField] = useState(false);
    const [inquiryValue,setInquiryValue] = useState(null);
    let [showSubInq, setShowSubInq] = useState((config?.PreChatSurvey?.HideSubInquiry == "1") ? true : false)
    let [depositPlaceholder, setDepositPlaceholder] = useState(null)
    let firstNameSchema = null;
    let lastNameSchema = null;
    let emailSchema = null;
    let productSchema = null;
    let inquirySchema = null;
    let depositSchema = null;
    const dispatch = useDispatch()
    
    if(config?.PreChatSurvey) {
        if(config?.PreChatSurvey?.UsernameRequired == 1) {
            firstNameSchema = Yup.string().matches(/^[a-zA-Z0-9\s]+$/g, config?.PreChatSurvey.UsernameErrorMessage).min(3, config?.PreChatSurvey.UsernameErrorMessage).max(30 ,config?.PreChatSurvey.UsernameErrorMessage).required(config?.PreChatSurvey.UsernameErrorMessage).trim().label(config?.PreChatSurvey.UsernamePlaceholder);
        } else {
            firstNameSchema = Yup.string().matches(/^[a-zA-Z0-9\s]+$/g, config?.PreChatSurvey.UsernameErrorMessage).min(3, config?.PreChatSurvey.UsernameErrorMessage).max(30, config?.PreChatSurvey.UsernameErrorMessage).trim().label(config?.PreChatSurvey.UsernamePlaceholder);  
        }

        if(config?.PreChatSurvey?.LastNameRequired == 1) {
            lastNameSchema = Yup.string().min(2).max(30).required(config?.PreChatSurvey.LastNameErrorMessage).trim().label(config?.PreChatSurvey.LastnamePlaceholder);  
        }
        
        if(config?.PreChatSurvey?.EmailRequired == 1) {
            emailSchema = Yup.string().email(config?.PreChatSurvey.EmailErrorMessage).required(config?.PreChatSurvey.EmailErrorMessage).label(config?.PreChatSurvey.EmailPlaceholder);  
        } else {
            emailSchema = Yup.string().email(config?.PreChatSurvey.EmailErrorMessage).label(config?.PreChatSurvey.EmailPlaceholder);  
        }
        if (config?.PreChatSurvey?.hideEmail == 1) {
            emailSchema = null;
        }

        if(config?.PreChatSurvey?.ProductRequired == 1) {
            productSchema = Yup.string().required(config?.PreChatSurvey.ProductErrorMessage).label('Product');  
        } else {
            productSchema = Yup.string().label('Product');  
        }

        if(config?.PreChatSurvey?.InquiryRequired == 1) {
            inquirySchema = Yup.string().required(config?.PreChatSurvey.InquiryErrorMessage).label('Inquiry');  
        } else {
            inquirySchema = Yup.string().label('Inquiry');  
        }

        /** 
        if(appPreChatSurvey?.depositRequired == 1) {
            depositSchema = Yup.string().required(appPreChatSurvey.depositErrorMessage).label('Deposit');  
        } else {
            depositSchema = Yup.string().label('Deposit');  
        }
        */


        if(config?.PreChatSurvey?.DepositRequired == 1) {
            depositSchema = Yup.string()
            .when('inquiry', (inquiry) => {
                if (inquiry && inquiry == "DP") {
                    return Yup.string().required(config?.PreChatSurvey.DepositErrorMessage);
                }
            });
        } else {
            depositSchema = Yup.string().label('Deposit');  
        }

        SignupSchema = Yup.object().shape({
            firstName:firstNameSchema,
            lastName: lastNameSchema,
            // displayName:Yup.string().min(3).max(12).required().label('Display Name'),
            email: emailSchema,
            product: productSchema,
            inquiry: inquirySchema,
            deposit: depositSchema,
        });

        productList = config?.PreChatSurvey?.ProductList;
        inquiryList = [{id: 0, Value: "", Brandname: config?.PreChatSurvey.EmptyProductLabel}, ...config?.PreChatSurvey.ProductList]

        subinquiryListNew = [{value: "", name: config?.PreChatSurvey.EmptySubInquiryLabel}]
    }
    
    const handleOnEscBtnPressed = ()=>{
        document.onkeydown = function(evt) {
            evt = evt || window.event;
            var isEscape = false;
            let isInChatComponent = document.activeElement.closest("chat-app")
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } 
            if (isEscape && isInChatComponent ) {
                
            //if(engagement?.data){
            //    dispatch(signOut())
            //}

            formikRef?.current?.resetForm()
            }
        };  
    }

    const changeSelectOptionHandler = (event) => {
        if(event.target.value == "DP" && lang == "KR") {
            setDepositField(true);
            setDepositPlaceholder(config?.PreChatSurvey?.depositPlaceholder)
        } 
        else if(event.target.value == "HA") {
        setDepositField(true);
        setDepositPlaceholder(config?.PreChatSurvey?.depositPlaceholderHA)
        } else {
        setDepositField(false);
        }
        
        if(config?.PreChatSurvey?.subinquiry?.[event.target.value]) {
        setShowSubInq(true);
        } else {
        setShowSubInq(false);
        }
/*
        if(event.target.value != "" && config?.PreChatSurvey.subinquiry[event.target.value]) {
            // subinquiryList = [{value: "", name: appPreChatSurvey.emptySubInquiryLabel}, ...appPreChatSurvey?.subinquiry?.[event.target.value]];
            subinquiryListNew = [{value: "", name: config?.PreChatSurvey.emptySubInquiryLabel}, ...config?.PreChatSurvey?.subinquiry?.[event.target.value]];

            setSubInquiryField(true)
        } else {
            subinquiryListNew = [{value: '', name: 'Please choose sub-inquiry'}];
            setSubInquiryField(false);
        }
            */
        setInquiryValue(event.target.value);
    }

    const clickCallHandler = (event) => {
        if(typeof config?.CallUs !== 'undefined' && (config?.CallUs?.enableLanguageSelector == 1)) {
            createCallSelectorUrl();
        } else {
            createCallUrl();
        }
    }

    const changeSubInquiryHandler = (event) => {
        //subinquiryListNew = (config?.PreChatSurvey.Subinquiry[inquiryValue]) ? [{value: "", name: config?.PreChatSurvey.EmptySubInquiryLabel}, ...config?.PreChatSurvey?.Subinquiry?.[inquiryValue]]
        //: [{value: '', name: 'Please choose sub-inquiry'}];
    }

    const preventNonNumericalInput = (e) => {
        e = e || window.event;
        var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        var charStr = String.fromCharCode(charCode);

        if (!charStr.match(/^[0-9]+$/))
            e.preventDefault();
    }

    useEffect(()=>{
        handleOnEscBtnPressed()
        dispatch(setPage('pre-chat'))
    },[])

    useEffect(()=>{
        if(user?.data && !user.isSignedOut){
            dispatch(setPage('chat'))
        }
    },[user?.data])


    const appGenerateSkillset = function(user) {
        var product = (user.country == 'MY' && user.product != 'FishHTR') ? user.product + user.country : user.product;

        if (user.proactiveJoin){
            product = 'Registration';
        }

        if (user.proactiveCashier) {
            if (user.country == 'MY') {
                product = 'ProActMY';
            } else {
                product = 'ProAct';
            }
        } 

        var cat = user.cat;
        cat = capitalizeWords(cat)
        if(cat == "Dafabet") {
            cat = "Dafa";
        }

        var options = [
                    'WC',
                    lang,
                    cat,
                    '__REG_PI'
                ];

        return options.join('_');
    }
    
    const generateUserLevel = function() {
    let level = 'REG';
    let levelInt = getUrlParam('level');
    let levelIntArr = [];

    if(levelInt) {
        if(["17", "26"].includes(levelInt)) {
        level = "VIP"
        } else if(["13", "18"].includes(levelInt)) {
        level = "Elite"
        } else {
        level = "REG"
        }
    }
    return level;
    }

    return (
        <>
            <div className='announcement'>
            { (config?.Announcement) ?
                <div id='livechat-announcement'>
                    <div className="live-chat-wrapper">
                        <div className="float-left icon-container">
                            <div className="centerer"></div>
                            <div className="icon-wrapper">
                                <img className="announcement-icon" width="50" height="50" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAeFBMVEUAAAB3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3c+RLoqAAAAJ3RSTlMA+wj1aD6yIQ8DLyft5cF+dxjNWFEV3dbHj4ZxQzcbuKmbo0kfYLsv/Q0cAAABtUlEQVQYGe3B53aiUABG0e/SpBcBe9fkvP8bDoKJAinMWvNz9tZ/3wtDPewsTTJLNuqELHaa4LBgqY4HZPrVYQFEajkGWOsXhwWNXJ2dDTj6UZRwt1LDdQLtY7Aj/cCN6RwkzZnftDPg6XuO4cGRXCAptAX2+oZ/4dNRUg6k0gou+pq74Mn4krZApSvYlr5QnOkp1fAgVZDATiNWFtN3UiME4+sEmfpqKWfIttRYgqsNXPTi5rybUCUjVzU8KJXBUR8O+ZxGJt8wdFbDg1IbSNWJPENrKR0ZigNJc3B1AU+tq82HmRxGXMk3GF9zWOsusvm01YGRtRQmpLIMOLrzeFpJK4YWkqy8kgvM1CgMT6ZQzkioVgap7ipeOYoYydSq1/ZVd2+8OkpLhuZ6KNSqeGV8bRiZqedGT6k9I1v1pbw6SQlDqfr2hhe2pWLWuNWzWeiW+TmNwdTqc3habnwN1e5bpIEq4c6sskhTWdX6vKlqScHuzdJf8MtTDMdAU/meTWurydZ07EhTWUs6c0tThYbOKdBUOQ9erYmCdx5iSxMVCZ1VoKn2NhCf3UDTFc52H+i/f+kPVWlon7RQG1IAAAAASUVORK5CYII="/>
                            </div>
                        </div>
                        <div className="float-left announcement-content">
                            <h2 className="announcement-title" >{ config.AnnouncementTitle }</h2>
                            <p className="announcement-text" dangerouslySetInnerHTML={{ __html: config.Announcement }}>
                            </p>
                        </div>
                    </div>
                </div> : null 
            }
            </div>
            { (config?.PreChatSurvey) ?
                <div id="live-chat-app">
                { (config?.PreChatSurvey) ? <div className='sign-in-form sign-in '>
                <Formik
                    role="form"
                    novalidate="novalidate"
                    innerRef={formikRef}
                    initialValues={{
                        firstName: playerData?.username || '',
                        name: (playerData) ? playerData.username : '',
                        lastName: '',
                        email: (playerData) ? playerData.email : '',
                        confirmationOrder:'',
                        product:'',
                        inquiry:'',
                        deposit:'',
                        engagementParamters:[],
                    }}
                    validationSchema={SignupSchema}
                    onSubmit={values => {
                        //@ts-ignore
                        user.brand = getUrlParam('brand') || 'Dafa';
                        user.level = generateUserLevel();
                        user.lang = lang || 'EN';
                        user.country = countryCode || config.countryCode || '';
                        //@ts-ignore
                        user.product = (values.product != "") ? values.product : (getUrlParam('product') || "");
                        //@ts-ignore
                        user.inquiry = (values.inquiry != "") ? values.inquiry : (getUrlParam('inquiry') || "");
                        
                        user.source = 'EWC';
                        //@ts-ignore
                        user.payment = getUrlParam('payment') || '';
                        //@ts-ignore
                        user.opm = getUrlParam('otherpayment') || 'NULL';
                        user.init_msg = config.init_msg;
                        user.referer = config.source || '';
                        user.refererPlatform = navigator.userAgent;
                        
                        if (config.playtech === true) {
                            user.source = 'Playtech';
                        }
                        let brand = 'dafabet';
                        
                        let brandMapping = {
                            'dfbt': 'dafabet',
                            'sevenbaby': '777baby'
                        };
                        brand = brandMapping[config?.Template?.Brand] ? brandMapping[config?.Template?.Brand] : config?.Template?.Brand;
                        
                        let product = user.product.toLowerCase();
                        
                        if (brand == 'zedbet' && (lang == "EN" || "KR"))  {
                            user.inquiry = 'GI';
                        }
                        
                        if(product == 'dafabet') {
                            product = "Dafabet";
                        }
                        if (window.location.pathname.split('/').pop() == 'dafa-spain') {
                            brand = 'dafabetes';
                        }
                        
                        if (window.location.pathname.split('/').pop() == 'dafa-spain') {
                            brand = 'dafabetes';
                        }
                        user.cat = brand || 'Dafa';
                        if(window.location.hostname == 'istg-chat.elysium-dfbt.com') {
                            brand = "istg-" + brand;
                            lang = "ISTG " + lang;
                        }

                        let skillset = appGenerateSkillset(user);
                        
                        let customValues = [];
                        customValues.push({ 'title': 'IP', 'value': ipAddress || config?.PreChatSurvey.clientIp || '202.151.35.161' });
                        customValues.push({ 'title': 'country', 'value': countryCode || config?.PreChatSurvey.countryCode || '' });
                        // customValues.push({ 'title': 'source', 'value': user.source });
                        customValues.push({ 'title': 'referer', 'value': user.referer });
                        customValues.push({ 'title': 'RefererPlatform', 'value': user.refererPlatform });
                        customValues.push({ 'title': 'CustomerVerified', 'value': playerData ? "true" : "false" });
                        customValues.push({ 'title': 'language', 'value': lang });
                        customValues.push({ 'title': 'CustomerSegment', 'value': user.level });
                        customValues.push({ 'title': 'SuggestedPM', 'value': user.payment });
                        customValues.push({ 'title': 'OtherPM', 'value': user.opm });
                        customValues.push({ 'title': 'Restart', 'value': 'false' });
                        customValues.push({ 'title': 'skillset', 'value': skillset });
                        
                        customValues.push({ 'title': 'username', 'value': values.firstName });
                        customValues.push({ 'title': 'name', 'value': values.firstName });
                        customValues.push({ 'title': 'email', 'value': values.email });
                        customValues.push({ 'title': 'phoneNumber', 'value': '' });
                        customValues.push({ 'title': 'product', 'value': product });
                        customValues.push({ 'title': 'inquiry', 'value': user.inquiry });
                        //@ts-ignore
                        customValues.push({ 'title': 'subinquiry', 'value': values.subinquiry });
                        customValues.push({ 'title': 'deposit', 'value': values.deposit });
                        
                        if(values.product) {
                            customValues.push({ 'title': 'Product', 'value': values.product })
                        }
                        
                        let engagementParamters = {
                            Brand: brand
                        };
                        
                        customValues.forEach((item)=>{
                            engagementParamters = {...engagementParamters, [item['title']]:item['value']}
                        })

                        let emailDom = '@dafabet.com';

                        if(brand == 'ftv' || brand == 'istg-ftv') {
                            emailDom = '@ftv.com' 
                        }

                        let userData = {
                            customerIdentifier: values.email ? values.email : brand + emailDom,
                            customerIdentifiers: {
                                emailAddresses: [values.email ? values.email : brand + emailDom],
                                username: [values.firstName ? values.firstName : brand]
                            },
                            displayName: values.firstName ? values.firstName : brand,
                            firstName: values.firstName ? values.firstName : brand,
                            emailAddress: values.email ? values.email : brand + emailDom,
                            engagementParamters: engagementParamters
                        }
                        dispatch(setPage('chat'))
                        // console.log(userData);
                        // dispatch(setEngagementParameters(engagementParamters))
                        dispatch(signIn(userData, engagementParamters))
                        
                    }}
                >
                {({ values , errors, touched , setFieldValue }) => (
                    <Form>
                        <h2 className="live-chat-title ng-binding">{ config?.PreChatSurvey.FormTitle }</h2>
                        {user?.signIn?.error?<div className='alert-danger'>
                            Failed to submit.
                        </div>:null}

                        <div
                            onBlur={()=>{
                                setFieldValue("firstName",values.firstName?.trimEnd(),true)
                            }}
                            className={clsx('form-control',{"invalid":errors.firstName && touched.firstName})}>
                            <label aria-label='first name' htmlFor="firstName"> First Name</label>
                            <img className="input-icon username" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAflBMVEUAAABycnOGhoZ1dXV2dnZmZmZwcHB4eHh2dnZ4eHh3d3dzc3Nvb29ra2t4eHh4eHh3d3d2dnZ1dXV0dHR4eHh4eHh4eHh4eHhmZmZvb293d3d3d3d3d3d3d3dycnJ4eHh3d3dmZmZnZ2dpaWpsbGx3d3d0dHRvb29xcXFxcXLGZWlGAAAAIXRSTlMAhxU4PQgYu0ajaicVD8Wog1I0K/Ds5d/dn5aLd1sh1n/fOQdrAAABWElEQVRIx62V2XKDMAxFVUxDWLLvayvZxvT/f7DA5IE2vg7u9LwweOaMJcuS6b8oc1vXNi9pJOnOCfeI26VjjEx4gMxfCpOGf9FMXgQl/IRMQ8bMsAczw8b7F3tp3qFyZj9yhpsYBhi0Tc6QHCgNVprwcUUc2kawIhuvMuUA/nLeQsrNq6xCysqrqJCi/JdYY0OD6+yw4shPjZUaKCqUCsAiwxJCaZC8Isin+AxZUoCtT9lSEKuforLBiXQlmnou5LVCfWylO/9qbwZ9sp909RLr7WQlfRibJElSo3tM2v6s+1BFPRuLRxJSp0lLdb9X3VfV8khpEZjE4i5FmbSUxcUNlrOfxlx4iGjTooXxRF9qHoEelHQtPApZwwH2um0yHk2G3hSMpLhLwp2jYxTdGQeO4kCkDAPgU/MhcYqsUE0wC5w8HmkSq7h4Reh0jDOOJ6LiLYqC/sA3r5++fOJwbw8AAAAASUVORK5CYII="></img>
                            <Field 
                                value={values.firstName}
                                id="firstName"
                                name="firstName"
                                className={ playerData?.username ? 'disabled' : ''}
                                type="textfield"
                                placeholder={config?.PreChatSurvey.UsernamePlaceholder}
                                aria-required="true"
                                aria-describedby="firstNameFeedback"
                                aria-invalid={errors.firstName && touched.firstName}
                            />
                            {errors.firstName && touched.firstName ? (
                                <div className='invalid-feedback' id="firstNameFeedback">{errors.firstName}</div>
                            ) : null }
                        </div>
                        
                        { ((config?.PreChatSurvey?.ShowLastname == true))  ? 
                        <div 
                            onBlur={()=>{
                                setFieldValue("lastName",values.lastName?.trimEnd(),true)
                            }}
                            className={clsx("form-control", {"invalid":errors.lastName && touched.lastName})}>
                            <label aria-label='last name'  htmlFor="lastName">Last Name</label>
                            <img className="input-icon username" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAflBMVEUAAABycnOGhoZ1dXV2dnZmZmZwcHB4eHh2dnZ4eHh3d3dzc3Nvb29ra2t4eHh4eHh3d3d2dnZ1dXV0dHR4eHh4eHh4eHh4eHhmZmZvb293d3d3d3d3d3d3d3dycnJ4eHh3d3dmZmZnZ2dpaWpsbGx3d3d0dHRvb29xcXFxcXLGZWlGAAAAIXRSTlMAhxU4PQgYu0ajaicVD8Wog1I0K/Ds5d/dn5aLd1sh1n/fOQdrAAABWElEQVRIx62V2XKDMAxFVUxDWLLvayvZxvT/f7DA5IE2vg7u9LwweOaMJcuS6b8oc1vXNi9pJOnOCfeI26VjjEx4gMxfCpOGf9FMXgQl/IRMQ8bMsAczw8b7F3tp3qFyZj9yhpsYBhi0Tc6QHCgNVprwcUUc2kawIhuvMuUA/nLeQsrNq6xCysqrqJCi/JdYY0OD6+yw4shPjZUaKCqUCsAiwxJCaZC8Isin+AxZUoCtT9lSEKuforLBiXQlmnou5LVCfWylO/9qbwZ9sp909RLr7WQlfRibJElSo3tM2v6s+1BFPRuLRxJSp0lLdb9X3VfV8khpEZjE4i5FmbSUxcUNlrOfxlx4iGjTooXxRF9qHoEelHQtPApZwwH2um0yHk2G3hSMpLhLwp2jYxTdGQeO4kCkDAPgU/MhcYqsUE0wC5w8HmkSq7h4Reh0jDOOJ6LiLYqC/sA3r5++fOJwbw8AAAAASUVORK5CYII="></img>
                            <Field 
                                id="lastName"
                                name="lastName"
                                type="textfield"
                                placeholder={config?.PreChatSurvey?.LastnamePlaceholder}
                                aria-required="true"
                                aria-describedby="lastNameFeedback"
                                aria-invalid={errors.lastName && touched.lastName}
                            
                            />
                            {errors.lastName && touched.lastName ? (
                                <div className='invalid-feedback' id="lastNameFeedback">{errors.lastName}</div>
                            ) : null}
                        </div> : null }
                        
                        { (!(config?.PreChatSurvey?.HideEmail)) ? <div 
                            onBlur={()=>{
                                setFieldValue("email",values.email?.trimEnd(),true)
                            }}
                            style={{
                                position: playerData ? 'absolute' : 'relative',
                                left: playerData ? '-9999px' : 'auto'
                            }}
                            className={clsx('form-control',{"invalid":errors.email && touched.email})}>
                            <label  aria-label='email'  htmlFor="email">Email Address</label>
                            <img className="input-icon email" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAgVBMVEUAAACEhISEhISDg4OAgICAgIB3d3eFhYV1dX
                            WFhYV1dXV0dHSFhYWDg4OFhYR1dXV3d3h4eHh+fn5/f391dXV4eHh+fn6BgYGCgoKEhIR5eXl5eXl6enp+fn+AgIBoaGhmZmZqamp+fn5wcHB9fX5xcXFtbW12dnZ0dHR3d3d4eHi/ViJfAAAAH3RSTlMAHxslUU7ND+UH7/UKLRTq0LZkV+HCbF41F+2mnIJMcYw+wgAAAYZJREFUSMft1NtygjAQgOENaRUEj2g9u1mQBHz/B+zKgEElUHvp+F845uIbiLMufHqjzskLnUuCL1USxen0D2nF1QSzRHiet/U6EkmGlhDpwoOevEIT1QQvOenlqVuclpryC9YkFnNN6SFwg+CQkl7J+Ea+ARYZ0mDoEtGAMPsB+GoSkL6i2dAp1GgMjwQmvus5Q37GaAvPBDyf2LQKGgloIyCvJmp5KwolPBNr5L2QLPgeLgJiSRgummIRIk0luAkEc416H9yOez7O+egm3DhValYfBkqlG4AesmGiplA2VZZ0vxgpDIELUREfV0EXET5hflznyIYF5utjbq/v+pGLMUvDhp0RfLeCaCSfiRUmAiiNUmgkcJGpjGNgzKQaEsPfq+GZXI0H0D6WLOp2O/6offtYjn1FxjX8pm34fzKkwiH4OcX1LxY0SCxXmtJZBM6CWUp6IGNsrot8AZ2t82pd2KUkoSdRLSW7+qToSVarzy7Y7C5ep9ljdsH+Z40n5xdK4NP79AtfflN2wFq/ygAAAABJRU5ErkJggg=="></img>
                            <Field 
                                className={(config?.PreChatSurvey?.customerVerified === 'true') ? 'hide-text' : ''}
                                id="email"
                                name="email"
                                type="email"
                                placeholder={(config?.PreChatSurvey?.EmailPlaceholder)}
                                aria-required="true"
                                aria-describedby="emailFeedback"
                                aria-invalid={errors.email && touched.email}
                                autoComplete="off"
                            />
                            {errors.email && touched.email ? (
                                <div className='invalid-feedback' id="emailFeedback">{errors.email}</div>
                            ) : null }
                        </div> : null }
                            
                        { (!(config?.PreChatSurvey?.HideProduct) && productList) ? <div 
                            onBlur={()=>{
                                setFieldValue("product",values.product?.trimEnd(),true)
                            }}
                            className={clsx('form-control',{"invalid":errors.product && touched.product})}>
                            <label  aria-label='product'  htmlFor="product">Email Address</label>
                            <Field 
                                as="select" 
                                className="avaya-survey-select" 
                                name="product"
                                aria-describedby="productFeedback">
                                { (productList) ? productList.map(productItem => {
                                    return (
                                        <option key={productItem.Value}
                                        value={ productItem.Value } >{ productItem.Brandname }</option>
                                    );
                                })
                                : null }
                            </Field>
                            {errors.product && touched.product ? (
                                <div className='invalid-feedback'  id="productFeedback">{errors.product}</div>
                            ) : null}
                        </div> : null }

                        { !(config?.PreChatSurvey?.HideInquiry && Array.isArray(config?.PreChatSurvey?.InquiryandSubinquiryList) && config?.PreChatSurvey?.InquiryandSubinquiryList.length > 0) ? (
                            <div 
                                onBlur={() => {
                                    setFieldValue("inquiry", values.inquiry?.trimEnd(), true);
                                }}
                                onChange={changeSelectOptionHandler}
                                onClick={changeSubInquiryHandler}
                                className={clsx('form-control', { "invalid": errors.inquiry && touched.inquiry })}
                            >
                                <label aria-label='inquiry' htmlFor="inquiry">Inquiry</label>
                                <Field 
                                    as="select" 
                                    className="avaya-survey-select" 
                                    name="inquiry"
                                    id="inquiry"
                                    aria-describedby="inquiryFeedback"
                                >
                                    {Array.isArray(config?.PreChatSurvey?.InquiryandSubinquiryList) &&
                                        config?.PreChatSurvey?.InquiryandSubinquiryList.map(inquiry => {
                                            return inquiry.display ? (
                                                <option key={inquiry.value} value={inquiry.value}>
                                                    {inquiry.Label}
                                                </option>
                                            ) : null;
                                        })
                                    }
                                </Field>
                                {errors.inquiry && touched.inquiry ? (
                                    <div className='invalid-feedback' id="inquiryFeedback">{errors.inquiry}</div>
                                ) : null}
                            </div>
                        ) : null}
                                    
                        { ( showSubInq ) ? <div 
                            onBlur={()=>{
                                setFieldValue("subinquiry",values.subinquiry?.trimEnd(),true)
                            }}
                            
                            className={clsx('form-control',{"invalid":errors.inquiry && touched.inquiry})}>
                            <label  aria-label='subinquiry'  htmlFor="subinquiry">Inquiry</label>
                            <Field 
                                as="select" 
                                name="sub-inquiry"
                                className= {subInquiryField ? "avaya-survey-select" : "disabled avaya-survey-select"}
                                aria-describedby="subinquiryFeedback">
                                { (subInquiryField && subinquiryListNew.length) ? subinquiryListNew.map(subinquiry => {
                                    return (
                                        <option key={subinquiry.value}
                                        value={ subinquiry.value } >{ subinquiry.name }</option>
                                    );
                                })
                                : subinquiryListNew.map(subinquiry => {
                                    return (
                                        <option key={subinquiry.name}
                                        value={ subinquiry.value } >{ subinquiry.name }</option>
                                    );
                                }) }
                            </Field>
                            {errors.subinquiry && touched.subinquiry ? (
                                <div className='invalid-feedback' id="productFeedback">{errors.subinquiry}</div>
                            ) : null}
                        </div> : null }

                        { ((config?.PreChatSurvey?.ShowDeposit == true) && depositField ) ? <div 
                            onBlur={()=>{
                                setFieldValue("deposit",values.deposit,true)
                            }}
                            onKeyPress={preventNonNumericalInput}
                            className={clsx('form-control',{"invalid":errors.deposit && touched.deposit})}>
                            <label  aria-label='deposit'  htmlFor="deposit">deposit</label>
                            <img className="input-icon deposit" src="data:image/png;base64,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"></img>
                            <Field 
                                id="deposit"
                                name="deposit"
                                type="number"
                                placeholder={depositPlaceholder}
                                aria-required="true"
                                aria-describedby="depositFeedback"
                                aria-invalid={errors.deposit && touched.deposit}
                            />
                            { ((config?.PreChatSurvey?.ShowDepositDescription == "1") ) ?   
                                <div>
                                    <span className='field-description'>새로운 입금방식 가이드를 <a href="https://m.nonggufun.com/kr/lbt-self-guide" target="_blank">여기서</a> 확인해보세요!</span>
                                </div>
                            : null }
                            
                            {errors.deposit && touched.deposit ? (
                                <div className='invalid-feedback' id="depositFeedback">{errors.deposit}</div>
                            ) : null}
                        </div> : null }
                                        
                    </Form>
                )}
                </Formik>
                                    
                <div className='sign-in-footer'>
                    <button  className="submit-btn" aria-label={ config?.PreChatSurvey?.SubmitButtonText}  type="submit" onClick={()=>{
                            formikRef.current?.submitForm()
                        }} disabled={user?.signIn?.loading}>
                        {user?.signIn?.loading?<BeatLoader color={'#fff'} />:<> { config?.PreChatSurvey?.SubmitButtonText }</>}
                    </button>
                    { (config?.CallUs?.ShowPreChatCallUsBtn && config?.CallUs?.ShowPreChatCallUsBtn == 1) ? <button onClick={ clickCallHandler } id="prechat-call-button">{ config?.CallUs?.SubmitButton }</button> : null }
                </div>
            </div> : null } 
            </div> : null }
        </>
    )
}

export default PreChat;
